import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import rootReducer from './slices';
import reportWebVitals from './reportWebVitals';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // Disable retries globally for queries
      staleTime: 60000, // Data is considered fresh for 1 minute
      refetchOnWindowFocus: false, // Disable refetching on tab change
    },
    mutations: {
      retry: 0, // Disable retries globally for mutations
    },
  },
});

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
